module.exports = __webpack_public_path__ + "img/icon-type.1f6d3a07.svg";